import { MinusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, message, Modal, Row, Select, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { HeaderTitle } from "../../../components/styled-components";
import { GET, POST } from "../../../services";
import {
  EDIT_ITEM_BY_ORDER,
  GET_ORDER_DETAIL_BY_ORDERNO,
  GETALLPRODUCT,
} from "../../../services/path";

const { Option } = Select;

interface SubRowData {
  no: string;
  sku: string;
  namesku: string;
  qty: number;
  skuOld: string;
}

interface ItemData {
  no: string;
  sku: string;
  namesku: string;
  qty: number;
  QTYcut: number;
  size: string;
  price: number;
  subRows?: SubRowData[];
}

interface Product {
  SKU: string;
  itemName: string;
  sizeID: number;
  sizeName: string;
}

interface NewSku {
  itemName: string;
  price: number;
  qty: number;
  sizeID: number;
  sizeName: string;
  sku: string;
}

interface EditItem {
  no: number;
  oldItemName: string;
  oldSku: string;
  qty: number;
  newSkus: NewSku[];
}

const Editoneorder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderNumber, no, soNo } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [allProduct, setAllProduct] = useState<Product[]>([]);
  const [orderLineData, setOrderLineData] = useState<ItemData[]>([]);
  const [newOrderLineData, setNewOrderLineData] = useState<ItemData[]>([]);
  const [remark, setRemark] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addsubItem, setaddsubItem] = useState(false);
  const [tableData, setTableData] = useState<SubRowData[]>([]);
  const [skuBefore, setskuBefore] = useState<string>("");
  const [qtyBefore, setqtyBefore] = useState<number>(0);
  const [selectedItemBefore, setSelectedItemBefore] = useState<ItemData>();
  const [newRows, setNewRows] = useState<SubRowData[]>([]);

  // Open Modal
  const openModal = (record: ItemData) => {
    setskuBefore(record.sku);
    setqtyBefore(record.qty);
    setSelectedItemBefore(record);
    setIsModalOpen(true);
    setNewRows([{ no: record.no, skuOld: record.sku, sku: "", namesku: "", qty: 1 }]);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
    setNewRows([{ no: "", skuOld: "", sku: "", namesku: "", qty: 1 }]);
  };

  // Handle adding new rows dynamically
  const addRow = () => {
    // Calculate the total qty in newRows
    const totalQty = newRows.reduce((sum, row) => sum + row.qty, 0);

    // Check if adding a new row exceeds the allowed quantity
    if (totalQty + 1 > qtyBefore) {
      message.error(`เลือกจำนวนเกินสินค้าที่มีอยู่`);
    } else {
      setNewRows([...newRows, { no: "", skuOld: skuBefore, sku: "", namesku: "", qty: 1 }]);
    }
  };

  const handleChange = (index: number, field: "sku" | "namesku", value: string) => {
    const updatedRows = [...newRows];
    if (field === "sku") {
      const selectedItem = allProduct.find((item) => item.SKU === value);
      updatedRows[index].sku = value;
      updatedRows[index].namesku = selectedItem ? selectedItem.itemName : "";
      updatedRows[index].skuOld = skuBefore;
    } else if (field === "namesku") {
      const selectedItem = allProduct.find((item) => item.itemName === value);
      updatedRows[index].namesku = value;
      updatedRows[index].sku = selectedItem ? selectedItem.SKU : "";
      updatedRows[index].skuOld = skuBefore;
    }

    setNewRows(updatedRows);
  };

  const handleRemoveRow = (i: number) => {
    setNewRows(newRows.filter((_, index) => index !== i));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (tableData.length === 0) {
        message.error(`ไม่มีรายการที่แก้ไข`);
      } else if (remark === "") {
        message.error(`กรุณากรอก Remark!`);
      } else {
        const editData = mapToEditItems(tableData);
        const obj = {
          orderNo: orderNumber,
          remark: remark,
          SoNo: soNo,
          editItems: editData,
        };

        const result = await POST(EDIT_ITEM_BY_ORDER, obj); //EDIT_ITEM_BY_ORDER
        if (result.success) {
          message.success("แก้ไขสำเร็จ");
          navigate(`/editsku/editoneorder-table`);
        }
      }
    } catch (error: any) {
      message.error(error.data.message);
    } finally {
      setLoading(false);
    }
  };

  function mapToEditItems(data: SubRowData[]): EditItem[] {
    const groupedData = data.reduce<Record<string, EditItem>>(
      (acc, item) => {
        const { no, skuOld, namesku, sku, qty } = item;
        const itemDetail = allProduct.find((item) => item.SKU === sku);
        if (!acc[skuOld]) {
          acc[skuOld] = {
            no: parseInt(no, 10),
            oldItemName: namesku,
            oldSku: skuOld,
            qty: 0,
            newSkus: [],
          };
        }

        acc[skuOld].qty += qty;
        if (sku !== skuOld) {
          acc[skuOld].newSkus.push({
            itemName: namesku,
            price: 0,
            qty,
            sizeID: itemDetail?.sizeID || 0,
            sizeName: itemDetail?.sizeName || "",
            sku,
          });
        }

        return acc;
      },
      {} as Record<string, EditItem>,
    );

    // Convert the grouped object into an array
    return Object.values(groupedData);
  }

  const calculateTotalQty = () => {
    return newRows.reduce((sum, row) => sum + row.qty, 0);
  };

  const handleSubmitmodal = () => {
    const hasEmptySKU = newRows.some((row) => row.sku === "");
    const totalQty = newRows.reduce((sum, row) => sum + row.qty, 0);
    const selectedItem = allProduct.find((item) => item.SKU === skuBefore);
    const olditem: SubRowData = {
      no: selectedItemBefore?.no || "",
      skuOld: skuBefore,
      sku: selectedItem?.SKU || "",
      namesku: selectedItem?.itemName || "",
      qty: qtyBefore - totalQty,
    };

    if (hasEmptySKU) {
      message.warning("Please fill in all SKU fields before submitting.");
      return; // Prevent submission if any SKU is empty
    } else {
      if (totalQty < qtyBefore) {
        setTableData((prevData) => [...prevData, ...newRows, olditem]);
      } else {
        setTableData((prevData) => [...prevData, ...newRows]);
      }

      setaddsubItem(true);
      setqtyBefore(0);
      setskuBefore("");
      closeModal();
      setNewOrderLineData(newOrderLineData.filter((item) => item.no !== selectedItemBefore?.no));
      setSelectedItemBefore(undefined);
    }
  };

  const columns = [
    {
      title: "SKU",
      key: "sku",
      dataIndex: "sku",
    },
    {
      title: "Item Name",
      key: "namesku",
      dataIndex: "namesku",
    },
    {
      title: "QTY",
      key: "qty",
      dataIndex: "qty",
    },
    {
      title: "Edit",
      key: "edit",
      render: (_: any, record: ItemData) => <Button onClick={() => openModal(record)}>Edit</Button>,
    },
  ];

  const handleRemark = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRemark(e.target.value);
  };

  const columnsunrow = [
    {
      title: "SKU Old",
      dataIndex: "skuOld",
      key: "skuOld",
      render: (value: string, _: SubRowData, index: number) => {
        // Check if the previous row has the same skuOld
        const isPreviousSame = index > 0 && tableData[index - 1].skuOld === value;

        // Calculate the rowSpan
        const count = tableData.filter((item) => item.skuOld === value).length;

        // If the current row is the first occurrence of the SKU, display it with rowSpan
        if (!isPreviousSame) {
          return {
            children: value,
            props: {
              rowSpan: count, // Set the rowSpan for merging
            },
          };
        } else {
          // If it's a duplicate SKU, return null to avoid rendering
          return {
            children: null, // No content for merged rows
            props: {
              rowSpan: 0, // Set to 0 to collapse the row
            },
          };
        }
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: "NameSKU",
      dataIndex: "namesku",
      key: "namesku",
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
    },
  ];

  const fetchOrderDetail = async () => {
    try {
      setLoading(true);
      const result = await GET(GET_ORDER_DETAIL_BY_ORDERNO(orderNumber, no)); //GET_ORDER_DETAIL_BY_ORDERNO(orderNumber, no)
      setOrderLineData(
        result.result.orderLines.map((item: any) => ({
          no: item.no,
          sku: item.sku,
          namesku: item.itemName,
          size: item.itemSize,
          qty: item.qty,
          price: item.price,
        })),
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProduct();
    fetchOrderDetail();
  }, []);

  useEffect(() => {
    setNewOrderLineData(orderLineData);
  }, [orderLineData]);

  const fetchAllProduct = async () => {
    try {
      const result = await GET(GETALLPRODUCT); //GETALLPRODUCT
      setAllProduct(result.result);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <LoginedLayout>
      <Spin spinning={loading}>
        <ContentBox>
          <HeaderTitle>
            <h2>{orderNumber}</h2>
          </HeaderTitle>
          <div>
            <Table
              dataSource={newOrderLineData}
              columns={columns}
              scroll={{ x: 750 }}
              pagination={false}
              style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}
            />
            <Modal
              width={800}
              title={<h3>Edit SKU : {skuBefore}</h3>}
              open={isModalOpen}
              onCancel={closeModal}
              footer={null}
            >
              <strong style={{ marginBottom: "10px" }}>
                จำนวนสินค้าที่แก้ไข : {calculateTotalQty()}
              </strong>
              {newRows.map((row, index) => (
                <div key={index} style={{ marginBottom: "10px" }}>
                  <Form layout="vertical">
                    <Row gutter={10}>
                      <Col span={8}>
                        {/* SKU Select */}
                        <Form.Item label="SKU">
                          <Select
                            style={{ width: "100%" }}
                            value={row.sku}
                            onChange={(value) => handleChange(index, "sku", value)}
                            placeholder="Select SKU"
                            showSearch
                          >
                            {allProduct.map((item, i: number) => (
                              <Option key={`${i}-${item.SKU}`} value={item.SKU}>
                                {item.SKU}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={13}>
                        <Form.Item label="SKU Name">
                          <Select
                            style={{ width: "100%" }}
                            value={row.namesku}
                            onChange={(value) => handleChange(index, "namesku", value)}
                            placeholder="Select NameSKU"
                            showSearch
                          >
                            {allProduct.map((item, i: number) => (
                              <Option key={`${i}-${item.itemName}`} value={item.itemName}>
                                {item.itemName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Form.Item label="QTY">
                          <Input
                            style={{ width: "100%" }}
                            type="number"
                            value={row.qty}
                            onChange={(e) => {
                              const newQty = parseInt(e.target.value) || 1;
                              const totalQty = calculateTotalQty() - row.qty + newQty;

                              // Check if new quantity exceeds qtyBefore
                              if (totalQty > qtyBefore) {
                                message.error("เลือกจำนวนเกินสินค้าที่มีอยู่");
                                return;
                              }

                              const updatedRows = [...newRows];
                              updatedRows[index].qty = newQty;
                              setNewRows(updatedRows);
                            }}
                            placeholder="Qty"
                          />
                        </Form.Item>
                      </Col>
                      {index > 0 && (
                        <Col span={1}>
                          <Form.Item label=" ">
                            <MinusOutlined
                              color="red"
                              onClick={() => {
                                handleRemoveRow(index);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Form>
                </div>
              ))}
              <Button type="dashed" onClick={addRow} block>
                เพิ่มรายการ
              </Button>
              <Button
                type="primary"
                onClick={handleSubmitmodal}
                style={{
                  marginTop: "10px",
                  color: "#ffff",
                  backgroundColor: "#34C759",
                }}
                block
              >
                บันทึก
              </Button>
            </Modal>
            {addsubItem && (
              <>
                <div style={{ marginTop: "50px" }}>
                  <Form.Item label="Remark">
                    <Input maxLength={250} showCount onChange={handleRemark} value={remark} />
                  </Form.Item>
                </div>
                <Table
                  columns={columnsunrow}
                  dataSource={tableData}
                  rowKey="skuOld" // Define a unique key for rows
                  style={{
                    marginTop: "50px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  }}
                  pagination={false}
                />
                <div
                  className="button-submit"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    type="primary"
                    onClick={handleSubmit}
                    style={{ marginTop: "20px", backgroundColor: "#51bd9a" }}
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
          </div>
        </ContentBox>
      </Spin>
    </LoginedLayout>
  );
};

export default Editoneorder;
